export const API = 'https://api.fairfieldcity.nsw.gov.au';